export default __webpack_public_path__ + "static/media/loic.e262cef1.jpg";